module.exports = __webpack_public_path__ + "static/media/twitter-grey.16e4a740.svg";